<template>
  <div class="wrap">
    <Navbar background="transparent" fixed />
    <!-- <ServiceBtn textShow />
    <div class="logo">
      <img :src="require('@/assets/logo/login.png')" class="logo_img" alt="">
    </div>
    <div class="deline">
      <div class="left"></div>
      <div class="text">{{ $t("partner") }}</div>
      <div class="right"></div>
    </div>
    <div class="partners">
      <img :src="require(`@tt/assets/login/patner/all.png`)" alt="" class="partner_img">
    </div> -->
    <div class="form_wrap_bar">
      <div class="logo">
        <img :src="require('@/assets/logo/login.png')" class="logo_img" alt="" />
      </div>
      <LoginForm :formList="formList" cancelText="Login.Forgot.goBack" confirmText="page.registrasi"
        readText="hint.registeRead" :needRead="true" @cancel="handleClose" @submit="onSubmit" @formValue="formChange">
        <template slot="surfix_code">
          <div class="send" @click="send">{{ isSendCodeClick ? $t('phoneVerify.btn.send') : auth_time }}</div>
        </template>
      </LoginForm>
      <div class="already_account">
        <span>{{ $t("已有账户") }}</span>
        <span @click="handleClose" class="register">{{
          $t("page.login")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import { Icon, Image as VImg, Toast } from "vant";
import LoginForm from "./components/form.vue";
import { SEND_SMS_CODE, LOGIN } from "@/api";
import { getNewPhone } from "@/utils/tools";
import { getCookieValue, baseEncode } from "@/utils/common";
import ServiceBtn from "@/components/serviceBtn";
import antiShake from "@/utils/anti-shake";
export default {
  components: {
    Icon,
    VImg,
    LoginForm,
    ServiceBtn,
    Navbar,
  },
  data() {
    return {
      formList: [
        {
          key: "userphone",
          flag: true,
          // icon: "icon-yonghuming",
          label: "Login.nameInput",
          needTrue: true,
          rules: [{ required: true, message: this.$t("hint.usernameEnter") }],
        },
        {
          key: "code",
          flag: true,
          label: "phoneVerify.placeholder.code",
          rules: [{ required: true, message: this.$t("phoneVerify.placeholder.code") }],
        },
        {
          label: "Login.Daftar.password",
          type: "password",
          key: "userpass",
          // icon: "icon-zhanghumima",
          flag: true,
          rules: [{ required: true, message: this.$t("hint.passwordEnter") }],
          isPassword: true,
        },
        {
          label: "Login.Daftar.againPassword",
          type: "password",
          key: "againPassword",
          // icon: "icon-zhanghumima",
          flag: false,
          rules: [
            { required: true, message: this.$t("hint.passwordAgainEnter") },
          ],
          isPassword: true,
        },
        {
          label: "Login.Daftar.referrer",
          type: "text",
          // icon: "icon-yaoqing2",
          key: "fromid",
          flag: true,
          rules: [{ required: true, message: this.$t("hint.formidEnter") }],
        },
      ],
      form: {},
      isSendCodeClick: true,
      auth_time: 0,
    };
  },
  methods: {
    formChange(_val) {
      console.log(_val);
      this.form = _val;
    },
    send: antiShake.debounce(function (e) {
      if (!this.isSendCodeClick) return;
      if (!this.form.userphone) return this.$toast(this.$t('hint.usernameEnter'));
      let form = {
        userphone: this.form.country_code + this.form.userphone,
        must: 1,
      };
      Toast.loading();
      SEND_SMS_CODE(form).then((r) => {
        if (r.data.ret === 1) {
          Toast(r.data.msg);
          this.isSendCodeClick = false;
          this.auth_time = 60;
          let auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.isSendCodeClick = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        } else {
          Toast(r.data.msg);
        }
      }).catch((e) => {
        Toast.clear();
      });
    }, 200),
    onSubmit(values) {
      Toast.loading({ duration: 0 });
      const { againPassword, ...useValues } = values;
      if (againPassword === useValues.userpass) {
        if (!this.formList.find((item) => item.key === "code")) {
          useValues.code = "112233";
        }
        LOGIN({
          ...useValues,
          channel: getCookieValue("channel") || baseEncode(),
        })
          .then((r) => {
            if (r.data.ret === 1) {
              this.$cookie.set("userInfo", JSON.stringify(r.data.data));
              this.$cookie.set("token", r.data.data.token);
              if (this.$cookie.get("fromid")) {
                this.$cookie.remove("fromid");
              }
              this.$store.dispatch("getSystemConfig");
              this.$router.replace("goods");
            } else {
              Toast.clear();
              Toast(r.data.msg);
            }
          })
          .catch((e) => {
            Toast.clear();
            console.log(e);
          });
        return;
      }
      Toast(this.$t("Hint.pwdInconformity"));
    },
    handleClose() {
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background: var(--bg);
  min-height: 100vh;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url("../../assets/login/bg.png");
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/ .service_btn {
    position: fixed;
    top: calc(20rem / 16);
    right: calc(20rem / 16);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .nav {
    // height: calc(50rem / 16);
    color: var(--textColor);
    display: flex;
    align-items: center;
    margin: calc(26rem / 16) calc(17rem / 16) 0;

    .back {
      transform: rotate(90deg);
    }

    .title {
      font-size: calc(24rem / 16);
      margin-left: calc(14rem / 16);
    }
  }

  .deline {
    padding: 0 calc(17rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: calc(30rem / 16);
    color: var(--light);

    .left {
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 1));
    }

    .text {
      margin: 0 calc(10rem / 16);
    }

    .right {
      .left();
      background: linear-gradient(90deg,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0));
    }
  }

  .partners {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: calc(15rem / 16) calc(17rem / 16) calc(15rem / 16);

    >.partner_img {
      // height: 60px;
      width: 100%;
    }
  }

  .form_wrap_bar {
    width: 90%;
    background-color: #470707;
    padding: calc(32rem / 16) 0 calc(23rem / 16);
    border-radius: 8px;

    .logo {
      display: flex;
      justify-content: center;

      &_img {
        height: calc(60rem / 16);
        display: block;
      }
    }

    .send {
      min-width: 40px;
      background: #fff;
      padding: 1px 6px;
      height: 30px;
      color: #953535;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
    }
  }

  .already_account {
    text-align: center;
    color: var(--light);
    font-size: calc(14rem / 16);
    margin-top: calc(15rem / 16);
    white-space: pre-wrap;

    .register {
      color: var(--yellow);
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
